module.exports = __webpack_public_path__ + "static/media/other.647dc7ca.svg";